import axios from "axios";
// import { COMETCHAT_CONSTANTS } from "src/configs/keys";
// import { CometChat } from "@cometchat-pro/chat";
import { cometLogoutUser } from '../../helper_functions/CometChatFunctions'
import { removeCometData } from "../cometChat/cometChatActions";
import { removeCommonState } from "../common/commonActions";
import {
  ADMIN_LOGIN,
  USER_LOGIN_SIGNUP_URL,
  ADMIN_USERS_API_URL,
  NOTIFICATIONS_API_URL,
} from "../../api_endpoints/API_URL";
import { showLoader, showToast } from "../common/commonActions";
import { fetchScams, submitScam } from "../scam/scamActions";

// Action (names)
export const USER_REQUEST_SENT = "USER_REQUEST_SENT";
export const GET_USER_SUCCESS = "GET_USER_SUCCESS";
export const UPDATE_BOTH_USER_ACTIVE_PANEL = "UPDATE_BOTH_USER_ACTIVE_PANEL";
export const GET_USER_FAILURE = "GET_USER_FAILURE";
export const GET_USER_LOGOUT = "GET_USER_LOGOUT";
export const SEND_NOTIFICATION = "SEND_NOTIFICATION";
export const NEW_NOTIFICATIONS = "NEW_NOTIFICATIONS";
export const ONLINE_USERS = "ONLINE_USERS";
export const COMET_ONLINE_USERS = "COMET_ONLINE_USERS";
export const SET_REFERRAL_LINK = "SET_REFERRAL_LINK"
export const SET_UTM_LINK = "SET_UTM_LINK"
export const SET_IS_ACTIVE_AS = "SET_IS_ACTIVE_AS"
export const SET_PREFERENCE = "SET_PREFERENCE"
export const SET_CONTINUE_AS = "SET_CONTINUE_AS"
export const SET_USER_TYPE = "SET_USER_TYPE"



// in Actions we return an object {type, payload}

// These Are the action Creator functions
//isForClient: all 4 payloads including continues_as
export const updateUserPreference = (data) => async (dispatch) => {
  // console.log(data)
  const url = data.continue_as === 'Student' ? '/updateUserPreferenceClient' : '/updateUserPreferenceExpert'
  try {
    const response = await axios.put(
      USER_LOGIN_SIGNUP_URL + url,
      JSON.stringify(data),
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    let active_as = '';
    if (data.continue_as === 'Student') {
      active_as = 'Client';
    } else if (data.continue_as === 'Writer' || data.continue_as === 'Writing Team') {
      active_as = 'Expert';
    } else {
      active_as = 'Client';
    }
    if (response.status === 200) {
      dispatch({
        type: SET_IS_ACTIVE_AS,
        payload: active_as
      });
      if (data.continue_as === 'Writer' || data.continue_as === 'Writing Team') {
        dispatch({
          type: SET_CONTINUE_AS,
          payload: {
            continue_as: response?.data?.updated_continue_as
            // continue_as:data.continue_as
          }
        });
        if (response?.data?.user_type !== undefined) {
          dispatch({
            type: SET_USER_TYPE,
            payload: response.data.user_type
          });
        }

      }
      if (data.continue_as === 'Student') {
        dispatch({
          type: SET_PREFERENCE,
          payload: {
            type_of_projects: data.type_of_projects,
            subjects: data.subjects,
            plan_post_project: data.plan_post_project,
            continue_as: response?.data?.updated_continue_as
          }
        });
      }
      return response
    }
  } catch (error) {
    console.error("Error updating active status:", error);
  }
};

export const getUserRequestSent = () => {
  const actionOBject = {
    type: USER_REQUEST_SENT,
  };
  return actionOBject;
};

export const getUserSuccess = (userData) => {
  let userInfo = userData
  if (userData?.userData?.role === 'Client/Expert' && !userInfo?.isActiveAs) {
    userInfo = {
      ...userInfo,
      isActiveAs: 'Client', // default value
    };
  }

  const actionOBject = {
    type: GET_USER_SUCCESS,
    payload: userInfo,
  };
  return actionOBject;
};

export const updateBothUserActiveAs = (isActiveAs) => {
  const actionOBject = {
    type: UPDATE_BOTH_USER_ACTIVE_PANEL,
    payload: isActiveAs,
  };
  return actionOBject;
}

export const sendNotification = (data) => {
  const actionOBject = {
    type: SEND_NOTIFICATION,
    payload: data,
  };
  return actionOBject;
};

export const newNotifications = (data) => {
  const actionOBject = {
    type: NEW_NOTIFICATIONS,
    payload: data,
  };
  return actionOBject;
};

export const onlineUsersList = (data) => {
  const actionOBject = {
    type: ONLINE_USERS,
    payload: data,
  };
  return actionOBject;
};

export const cometOnlineUsersList = (data) => {
  const actionOBject = {
    type: COMET_ONLINE_USERS,
    payload: data,
  };
  return actionOBject;
};

export const getUserFailure = (errorMessage) => {
  const actionOBject = {
    type: GET_USER_FAILURE,
    payload: errorMessage,
  };
  return actionOBject;
};

export const getUserLogout = () => {
  const actionOBject = {
    type: GET_USER_LOGOUT,
  };
  return actionOBject;
};

export const setReferralLink = (linkCode) => {
  const actionOBject = {
    type: SET_REFERRAL_LINK,
    payload: linkCode
  };
  return actionOBject;
};

export const setLinkUTM = (linkCode) => {
  const actionOBject = {
    type: SET_UTM_LINK,
    payload: linkCode
  };
  return actionOBject;
};

export const removeGlobalState = (timer = 100, replace = true) => (dispatch) => {
  dispatch(getUserLogout());
  setTimeout(() => {
    dispatch(removeCommonState())
    localStorage.clear();
    if (replace) {
      window.location.replace('/login')
    }
  }, timer)
}

// Need to create two functions that will add and remove access token in local storage

// Also, When we are using redux thunk, We can return a function in our action creator

// This is a new Action Creator that works only with Redux-Thunk Middleware
export const googleSignin = (email, type = 'user') => (dispatch, getState) => {
  let api_path = "";
  if (type === "admin") {
    // api_path = ADMIN_LOGIN + "/googleSigninAdmin";
    return;
  } else if (type === "user") {
    api_path = USER_LOGIN_SIGNUP_URL + "/google-user-login";
  }

  axios
    .post(`${api_path}`, { email })
    .then((response) => {
      if (response.status === 200 && !response.error) {
        // set scamState
        const userId = response.data.userData?.id;
        if (userId) {
          dispatch(fetchScams(userId));

          // Retrieve preScamData from state
          const preScamData = getState().scamState.preScamData;

          if (preScamData) {
            const formData = new FormData();
            formData.append("description", preScamData.description);
            formData.append("user_id", userId);

            // Prepare files (only append the binary files)
            if (preScamData.files && preScamData.files.length > 0) {
              preScamData.files.forEach((file, index) => {
                // Append the binary content of the file
                if (file.file instanceof Blob) {
                  formData.append(`file_${index}`, file.file);
                } else {
                  console.error(`Invalid file at index ${index}`);
                }
              });
            }
            dispatch(submitScam(formData));
          }
        }

        // Handle user roles
        if (
          response &&
          response.data &&
          response.data.userData &&
          response.data.userData.role === "Client/Expert"
        ) {
          const bothUserData = {
            ...response.data,
            isActiveAs: "Client", // default value
          };
          dispatch(getUserSuccess(bothUserData));
        } else {
          dispatch(getUserSuccess(response.data));
        }

        dispatch(showLoader({ show: false, msg: "" }));
      } else {
        dispatch(showToast({ show: true, msg: response.data.message }));
        dispatch(showLoader({ show: false, msg: "" }));
      }
    })
    .catch((error) => {
      dispatch(showLoader({ show: false, msg: "" }));
      const errorMessage = error?.response?.data?.message ?? false;
      if (errorMessage && typeof errorMessage === "string") {
        dispatch(showToast({ show: true, msg: errorMessage }));
        setTimeout(() => {
          dispatch(showToast({ show: false, msg: "" }));
        }, 3500);
      } else {
        dispatch(showToast({ show: true, msg: "Something went wrong" }));
        setTimeout(() => {
          dispatch(showToast({ show: false, msg: "" }));
        }, 3500);
      }
      // dispatch(getUserFailure(errorMessage));
    });
};

export const signin =
  (mail, pass, type) =>
    // inside of this function, we return another function
    (dispatch, getState) => {
      // Business logic
      // First, we need to set our loading to true
      //  dispatch(getUserRequestSent());
      let api_path = "";
      if (type === "admin") {
        api_path = ADMIN_LOGIN + "/signinAdmin";
      } else if (type === "user") {
        api_path = USER_LOGIN_SIGNUP_URL + "/signinUser";
      }
      axios
        .post(`${api_path}`, { email: mail, password: pass })
        .then((response) => {
          if (response.status === 200 && !response.error) {
            if (response && response.data && response.data.userData &&
              response.data.userData.role === 'Client/Expert') {
              const { continue_as } = response.data.userData
              // console.log(continue_as)
              let isActiveAs = ''
              if (continue_as === 'Student') {
                isActiveAs = 'Client'
              } else if (continue_as === 'Writer' || continue_as === 'Writing Team') {
                isActiveAs = 'Expert'
              } else {
                isActiveAs = "Client"
              }
              const bothUserData = {
                ...response.data,
                isActiveAs // default value
              };
              dispatch(getUserSuccess(bothUserData));
              const userId = response.data.userData?.id;
              if (userId) {
                dispatch(fetchScams(userId));

                // Retrieve preScamData from state
                const preScamData = getState().scamState.preScamData;

                if (preScamData) {
                  const formData = new FormData();
                  formData.append("description", preScamData.description);
                  formData.append("user_id", userId);

                  // Prepare files (only append the binary files)
                  if (preScamData.files && preScamData.files.length > 0) {
                    preScamData.files.forEach((file, index) => {
                      // Append the binary content of the file
                      if (file.file instanceof Blob) {
                        formData.append(`file_${index}`, file.file);
                      } else {
                        console.error(`Invalid file at index ${index}`);
                      }
                    });
                  }
                  dispatch(submitScam(formData));
                }
              }
            } else {
              dispatch(getUserSuccess(response.data));
            }
            // set scamState
            const userId = response.data.userData?.id;
            if (userId) {
              dispatch(fetchScams(userId));
            }
            dispatch(showLoader({ show: false, msg: "" }));
          } else {
            dispatch(showToast({ show: true, msg: response.data.message }));
            dispatch(showLoader({ show: false, msg: "" }));
          }
        })
        .catch((error) => {
          dispatch(showLoader({ show: false, msg: "" }));
          const errorMessage = error?.response?.data?.message ?? false
          if (errorMessage && typeof errorMessage === 'string') {
            dispatch(showToast({ show: true, msg: errorMessage }));
            setTimeout(() => {
              dispatch(showToast({ show: false, msg: "" }));
            }, 3500)
          } else {
            dispatch(showToast({ show: true, msg: 'Something went wrong' }));
            setTimeout(() => {
              dispatch(showToast({ show: false, msg: "" }));
            }, 3500)
          }
          // dispatch(getUserFailure(errorMessage));
        });
    };

export const signout =
  (tkn) =>
    // inside of this function, we return another function
    (dispatch) => {
      const token = `Bearer ${tkn}`;
      // Business logic
      // First, we need to set our loading to true
      //  dispatch(getUserRequestSent());
      axios({
        url: ADMIN_LOGIN + "/signoutAdmin",
        method: "POST",
        headers: {
          authorization: token,
        },
        data: {},
      }).then(() => {
        cometLogoutUser().then((data) => {
          //comet logout out 
          dispatch(showLoader({ show: false, msg: "" }));
          dispatch(removeCometData())
          dispatch(removeGlobalState())
        }).catch((err) => {
          dispatch(removeCometData())
          dispatch(showLoader({ show: false, msg: "" }));
          dispatch(removeGlobalState())
        })
        setTimeout(() => {
          dispatch(removeCommonState())
          localStorage.clear();
          window.location.replace('/login')
        }, 0)
      }).catch((error) => {
        const errorMessage = error.message;
        // dispatch(showToast({ show: true, msg: errorMessage }));
        dispatch(showLoader({ show: false, msg: "" }));
        dispatch(getUserFailure(errorMessage));
        localStorage.clear();
      });
    };

export const internalSignin =
  (mail, pass) =>
    // inside of this function, we return another function
    (dispatch) => {
      //  dispatch(getUserRequestSent());
      let endpoint = "internalSignin";

      axios
        .post(`${ADMIN_USERS_API_URL}/${endpoint}`, {
          email: mail,
          password: pass,
        })
        .then((response) => {
          if (response.status === 200 && !response.error) {
            if (response && response.data && response.data.userData &&
              response.data.userData.role === 'Client/Expert') {
              const bothUserData = {
                ...response.data,
                isActiveAs: 'Client',
              };
              dispatch(getUserSuccess(bothUserData));
            } else {
              dispatch(getUserSuccess(response.data));
            }
          }
        })
        .catch((error) => {
          const errorMessage = error.message;
          dispatch(getUserFailure(errorMessage));
        });
    };

export const bothPanelActiveAs = (activeAsValue) => (dispatch) => {
  dispatch(updateBothUserActiveAs(activeAsValue))
}

// updating notification status
export const updateNotificationStatus = (tkn, param, type) => (dispatch) => {
  const token = `Bearer ${tkn}`;
  axios({
    url: NOTIFICATIONS_API_URL + "/updateNotificationStatus",
    method: "POST",
    headers: {
      authorization: token,
    },
    data: { notification_id: param.id, status: 1, type },
  })
    .then(() => {
      if (type === "send_status") {
        // sending the notification to actual user
        // dispatch(newNotifications(param));
      }
      if (type === "seen_status") {
        // sending the notification to actual user
        dispatch(fetchNotifications(tkn, param));
      }
    })
    .catch((error) => { });
};

// fetching latest notification
export const fetchNotifications = (tkn, data) => (dispatch) => {
  const token = `Bearer ${tkn}`;
  axios({
    url: NOTIFICATIONS_API_URL + "/fetchNotifications",
    method: "POST",
    headers: {
      authorization: token,
    },
    data: { user_id: data.to_user_id },
  })
    .then((response) => {
      if (response.data.data.length > 0) {
        dispatch(newNotifications(response.data.data));
      }
    })
    .catch((error) => { });
};
